import { render, staticRenderFns } from "./ApiTokenDetails.vue?vue&type=template&id=a10ae946&"
import script from "./ApiTokenDetails.vue?vue&type=script&lang=js&"
export * from "./ApiTokenDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports